import { Component, computed, inject, model, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { UiButtonComponent } from '@app/shared/ui/button/ui-button.component';

import { SelectUserListComponent } from '@app/shared/components/select-user-list/select-user-list.component';
import { UsersDataService } from '@app/shared/services/users-data.service';
import { User } from '@app/shared/types/models/user/user.model';
import { UiDialogComponent } from '@app/shared/ui/dialog/ui-dialog.component';
import { TranslatePipe } from '@ngx-translate/core';

export interface SelectUserDialogData {
  titleKey: string;
  users?: User[];
  companyId?: string;
  preselectedUserId?: string;
}

/**
 * Generic single-user select modal — replaces legacy per-feature supervisor/client/admin modals.
 */
@Component({
  selector: 'proffeo-select-user-dialog',
  templateUrl: './select-user-dialog.component.html',
  imports: [TranslatePipe, UiDialogComponent, SelectUserListComponent, UiButtonComponent, MatDialogClose]
})
export class SelectUserDialogComponent implements OnInit {
  private readonly dialogRef = inject<MatDialogRef<SelectUserDialogComponent, User | undefined>>(MatDialogRef);
  private readonly usersDataService = inject(UsersDataService);

  protected readonly data = inject<SelectUserDialogData>(MAT_DIALOG_DATA);
  protected readonly selectedUserId = model<string | undefined>(this.data.preselectedUserId);
  protected readonly users = computed(() =>
    this.data.companyId ? (this.usersDataService.getCompanyUsers(this.data.companyId)() ?? []) : (this.data.users ?? [])
  );

  public ngOnInit(): void {
    if (this.data.companyId) {
      this.usersDataService.loadCompanyUsers(this.data.companyId);
    }
  }

  protected save(): void {
    const selectedUser = this.users().find(user => user.id === this.selectedUserId());
    this.dialogRef.close(selectedUser);
  }
}
